import axios from 'axios'

// config
import baseUrl from '../config'

export const generateUifDeclarationFile = async data => {
  return await axios({
    withCredentials: true,
    method: 'POST',
    url: `${baseUrl}/sef/generate-uif-declaration`,
    data
  })
}
